export const RECAPTCHA_URL = 'https://www.recaptcha.net/recaptcha/api.js';
export const generateCaptchaSettings = (RECAPTCHA_ORG_ID: string): string => {
  return `{"keyname":"reCAPTCHA","fallback":"true","orgId":"${RECAPTCHA_ORG_ID}","ts":"${JSON.stringify(
    new Date().getTime()
  )}"}`;
};
